export const cleanObject = (object) => {
  Object.keys(object).forEach((k) => (object[k] === undefined || object[k] === null) && delete object[k]);
  return object;
};
